import type React from 'react';

type AnyEl = JSX.Element | string | number;
type Props = {
  children: AnyEl | AnyEl[];
};

// eslint-disable-next-line react/jsx-no-useless-fragment
export const Trans: React.FC<Props> = ({ children }) => <>{children}</>;
